import { render, staticRenderFns } from "./AuthPanel.vue?vue&type=template&id=838dbc86&"
import script from "./AuthPanel.vue?vue&type=script&lang=ts&"
export * from "./AuthPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AuthPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports